import React from 'react';

function Logo(props) {
    const {dark} = props;
    return (
        <img
            style={{ width: 91 + 'px' }}
            alt="Logo"
            src={"/static/images/itmo-logo.dark.svg"}
            {...props}
        />
    );
}

export default Logo;
